export const ENQUIRY_PIPELINE_ADD_FORM = 'ENQUIRY_PIPELINE_ADD_FORM'
